import { ids } from "@icarros/theme-react";
import styled, { css } from "styled-components";
import { Sizes, Variants } from "./constants";
const { color, size } = ids || {};
const primary = css `
  background: ${color.action.primary.ids_color_action_primary_base};
`;
const gradient = css `
  background: ${color.backgrounds.ids_color_bg_brand_gradient};
`;
const thin = css `
  border-radius: ${size.general.ids_size_general_4x};
  height: ${size.general.ids_size_general_8x};
`;
const heavy = css `
  border-radius: ${size.general.ids_size_general_8x};
  height: ${size.general.ids_size_general_16x};
`;
const getBarSizeStyle = (size) => {
    switch (size) {
        case Sizes.thin:
            return thin;
        case Sizes.heavy:
            return heavy;
        default:
            return thin;
    }
};
const getBarVariantStyle = (variant) => {
    switch (variant) {
        case Variants.primary:
            return primary;
        case Variants.gradient:
            return gradient;
        default:
            return primary;
    }
};
export const StyledBar = styled.div `
  display: block;
  width: 100%;
  border: 0px none;
  background: ${color.action.disabled.ids_color_action_disabled_base};
  ${({ size }) => getBarSizeStyle(size)};
`;
export const StyledProgress = styled.span `
  display: block;
  border: 0px none;
  height: inherit;
  border-radius: inherit;
  ${({ variant }) => getBarVariantStyle(variant)};
  width: ${({ progress }) => progress};
`;
//# sourceMappingURL=ProgressBar.style.js.map